<ng-container [formGroup]="newEditForm">
    <td class="short" [ngClass]="{'show-error': showError}">
      <app-filterable-list [itemsList]="paises" [selectedItem]="newEditForm.get('pais')" [disabled]="disabledPais" [placeHolder]="false">
      </app-filterable-list>
    </td>
    <td class="short" [ngClass]="{'show-error': showError}">
      <app-filterable-list [itemsList]="denominaciones" [selectedItem]="newEditForm.get('denominacion')" [disabled]="disabledDenominacion" [placeHolder]="false">
      </app-filterable-list>
    </td>
    <td class="entry" [ngClass]="{'show-error': showError}" *ngIf="this.role === 'Administrador'">
      <app-filterable-list [itemsList]="allGrupoEtiquetasCaja" [selectedItem]="newEditForm.get('grupoEtiquetasCaja')" [disabled]="disabledCaja" [placeHolder]="false">
      </app-filterable-list>
    </td>
    <td class="entry" [ngClass]="{'show-error': showError}" *ngIf="this.role === 'Administrador'">
      <app-filterable-list [itemsList]="allGrupoEtiquetasPallet" [selectedItem]="newEditForm.get('grupoEtiquetasPallet')" [disabled]="disabledPallet" [placeHolder]="false">
      </app-filterable-list>
    </td>
    <td class="entry" [ngClass]="{'show-error': showError}" *ngIf="role === 'Administrador' || this.claims.includes('ETQ_PD_Upd_ImpAut')">
        <input type="checkbox" id="{{'autorizado' + randomId}}" formControlName="impresionAutorizada">
        <label for="{{'autorizado' + randomId}}" style="margin-bottom: unset;"></label>
    </td>
    <td class="entry" [ngClass]="{'show-error': showError}" *ngIf="role === 'Administrador' || this.claims.includes('ETQ_PD_Upd_ReimpAut')">
        <input type="checkbox" id="{{'reimp' + randomId}}" formControlName="reimpresionAutorizada">
        <label for="{{'reimp' + randomId}}" style="margin-bottom: unset;"></label>
    </td>
    <td class="multi-actions">
        <ng-container *ngIf="editable">
          <i class="far fa-save" title="{{'titles.guardar' | translate}}" (click)="save(denominacion)"></i>
          <i class="fas fa-times" title="{{'global.cancelar' | translate}}" (click)="cancel()"></i>
        </ng-container>
        <ng-container *ngIf="!editable">
          <i class="fa-solid fa-trademark" app-click-stop-propagation  title="{{'titles.marcasAsociadas' | translate}}" (click)="openMarcas(denominacion)"></i>
          <i class="fas fa-pencil-alt" app-click-stop-propagation title="{{'titles.editar' | translate}}" (click)="edit(denominacion)"></i>
          <i class="far fa-trash-alt" app-click-stop-propagation  *ngIf="this.role === 'Administrador'" title="{{'titles.eliminar' | translate}}" [ngClass]="{'disabled': (role !== 'Administrador' || (this.denominacion && this.denominacion.registroEnUso))}"
            (click)="askDelete()"></i>
        </ng-container>
    </td>
</ng-container>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
      <header>
        <h4>{{'global.eliminar.descripcion' | translate}}</h4>
      </header>
      <content>
        <p>{{'global.eliminar.confirmacion' | translate}}</p>
      </content>
      <footer>
        <button class="secondary" (click)="closeModal()">{{'global.cancelar' | translate}}</button>
        <button (click)="delete()">{{'global.confirmar' | translate}}</button>
      </footer>
    </div>
</div>
<app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
<div class="modal" *ngIf="marcasModal">
  <div class="modal-content" id="modal-table">
      <header>
          <h4>{{'mantenimientoDenominaciones.paisDenominacion.marcas.titulo' | translate }}</h4>
      </header>
      <app-marcas-etq-pais-denominacion class="component" [paisId]="paisId" [etiquetadorId]="etiquetadorId" [denominacionId]="denominacionId"
          (refresh)="toRefresh($event)"></app-marcas-etq-pais-denominacion>
  </div>
</div>
